import React from "react";
var __jsx = React.createElement;
import ErrorWrapper, { CTABlock, CTATitleBlock, ErrorTitleBlock, ErrorTitleBlockIcon, ErrorTitleBlockWrapper, ErrorTitleIconWrapper, FakeHeader, LogoWrapper } from './Wrapper';
var defaultErrorIconSrc = 'images/video-landings/icons/shrug.png';
var CTATitle = 'Make, host and share videos.<br/>Anywhere.';
var CTADescription = "Learn more at wave.video/tools/video-hosting";

var Error = function Error(_ref) {
  var iconSrc = _ref.iconSrc,
      description = _ref.description,
      title = _ref.title;
  return __jsx(React.Fragment, null, __jsx(FakeHeader, null, __jsx(LogoWrapper, {
    src: "images/logos/wv-logo-140.svg"
  })), __jsx(ErrorWrapper, {
    size: 720
  }, __jsx(ErrorTitleBlockWrapper, null, __jsx(ErrorTitleIconWrapper, null, __jsx(ErrorTitleBlockIcon, {
    src: iconSrc || defaultErrorIconSrc
  }), __jsx(ErrorTitleBlock, {
    size: "super-medium",
    title: title
  })), __jsx(ErrorTitleBlock, {
    size: "super-medium",
    description: description
  })), __jsx(CTABlock, null, __jsx(CTATitleBlock, {
    size: "medium",
    title: CTATitle,
    description: CTADescription
  }))));
};

export default Error;